import Vue from "vue";


// STATE
const state = {
	mode: "viewing",
	zoom: 100,
	scroll_to_section: false
};


// GETTERS
const getters = {
	editor: function (state) { return state; },
};


// ACTIONS
const actions = {

	set_mode: function ({ commit }, data) {
		commit("SET_EDITOR_STATE", { mode: data.mode });
	},

	set_zoom: function ({ commit }, data) {
		commit("SET_EDITOR_STATE", { zoom: data.zoom });
	},

	scroll_to_section: function ({ commit }, data) {
		commit("SET_EDITOR_STATE", { scroll_to_section: data.section });
	},


};


// MUTATIONS
const mutations = {

	SET_EDITOR_STATE: function (state, data) {
		for (const i in data) {
			Vue.set(state, i, data[i]);
		}
	},

};

export default { state, getters, actions, mutations };